/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ImagesIcon = ({ width = 24, height = 24, hidden = false, title = 'Images' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    data-name="outline / production"
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M17.02246,5.99998H5.97754c-1.09082,0-1.97754.84814-1.97754,1.89014v7.21973c0,1.04199.88672,1.89014,1.97754,1.89014h11.04492c1.09082,0,1.97754-.84814,1.97754-1.89014v-7.21973c0-1.04199-.88672-1.89014-1.97754-1.89014ZM5.97754,7.49998h11.04492c.25879,0,.47754.17871.47754.39014v5.73413l-1.33301-1.34595c-.75684-.76318-2.07617-.7627-2.83105.00049l-1.02441,1.03516-.11035-.00049-2.68945-2.71533c-.75488-.76367-2.0752-.76172-2.83008,0l-1.18164,1.1936v-3.90161c0-.21143.21875-.39014.47754-.39014ZM5.97754,15.49998c-.25879,0-.47754-.17871-.47754-.39014v-1.1853l2.24707-2.27075c.18848-.18848.51074-.18994.69922,0l2.68945,2.71533c.59668.604,1.64258.60645,2.24219-.00049l1.02441-1.03467c.1875-.18848.51074-.18945.69824,0l2.11121,2.13159c-.05859.02148-.12219.03442-.18933.03442H5.97754Z"
      fill="currentColor"
    />
    <path
      d="M1.75,13.99998c-.41406,0-.75-.33594-.75-.75V4.89012c0-1.04199.86621-1.89014,1.93164-1.89014h11.81836c.41406,0,.75.33594.75.75s-.33594.75-.75.75H2.93164c-.23828,0-.43164.1748-.43164.39014v8.35986c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <circle cx="14.29" cy="9.74998" r="1.1" fill="currentColor" />
  </svg>`;
};
